import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { getSyllabus } from '../Service/Api';
import LazyLoad from 'react-lazyload';

const Subject = () => {
    // const [data, setData] = useState([]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const syllabusData1 = await getSyllabus();
    //         const syllabusData = syllabusData1.filter((item) => item.category === "Syllabus")
    //         setData(syllabusData);
    //     };
    //     fetchData();
    // }, []);

    return (
        <>
            <Header />
            <Breadcrumb mid="Academics" breadcrumbName="Streams and Subjects" />
            <div className="innerSection">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h1>Streams and Subjects</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                                <div  className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                    <div className="video-gallery syllabus-tab">
                                        <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/pdf/Subjects-Streams.pdf" target="_blank" rel="noreferrer">
                                            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/pdf.png" alt="St. mary school, mirzapur" /></LazyLoad>
                                            <div>
                                                <h3>Subjects and Syllabus</h3>
                                                
                                            </div>
                                        </Link>
                                    </div>
                       </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Subject;
